import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>This page is not available right now</h1>
            <h1>404</h1>

        </div>
    );
};

export default NotFound;